import { render, staticRenderFns } from "./PartBase.vue?vue&type=template&id=dc5015a6"
import script from "./PartBase.vue?vue&type=script&lang=js"
export * from "./PartBase.vue?vue&type=script&lang=js"
import style0 from "./PartBase.vue?vue&type=style&index=0&id=dc5015a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports